import React, { useState } from "react";
import QRCode from "react-qr-code";
import AlertNew from "../../../../components/alert/AlertNew";
import { MODE } from "../../../../constants/common";
import Container from "../../../../shared/Container";
import H4 from "../../../../shared/typography/H4";
import P from "../../../../shared/typography/P";
import Button from "../../../../shared/ui/Button";
import BottomDrawer from "../../../../shared/ui/Drawer/BottomDrawer";
import RadioInput from "../../../../shared/ui/Form/RadioInput";
import BorderedTab from "../../../../shared/ui/tab/BorderedTab";
import SalesExecutiveWrapper from "../../SalesExecutiveWrapper";
import PaymentCard from "../PaymentCard";
import PaymentStatus from "../PaymentStatus";

const Payment = ({
    onClick,
    receipts,
    virtualAccount,
    paymentMode,
    setPaymentMode,
}) => {
    const [currentTab, setCurrentTab] = useState(0);

    const [showModal, setShowModal] = useState(false);

    const [showMode, setShowMode] = useState(false);

    return (
        <div>
            <div className="flex  justify-between font-urbanist gap-4">
                <SelectPayment
                    onMode={() => setShowMode(true)}
                    onClick={onClick}
                    receipts={receipts}
                />
                <div className="w-0.1 bg-gray-200 hidden xl:block" />
                <div className="hidden lg:block w-full">
                    <PaymentMode
                        type="desktop"
                        currentTab={currentTab}
                        paymentMode={paymentMode}
                        setCurrentTab={setCurrentTab}
                        setPaymentMode={setPaymentMode}
                        virtualAccount={virtualAccount}
                    />
                </div>
            </div>
            <SalesExecutiveWrapper
                setShowModal={setShowModal}
                showModal={showModal}
                assignee={{
                    designation: "Sales",
                    name: "Assigne name",
                    email: "assignne@email.com",
                    phoneNumber: "+99 9912345678",
                }}
            />
            <div className="lg:hidden">
                <BottomDrawer
                    isOpen={showMode}
                    onClick={() => setShowMode(false)}
                    contentClass="bg-white "
                    showClose={true}
                >
                    <Container className="pb-6.4">
                        <PaymentMode
                            type="mobile"
                            currentTab={currentTab}
                            paymentMode={paymentMode}
                            setCurrentTab={setCurrentTab}
                            setPaymentMode={setPaymentMode}
                            virtualAccount={virtualAccount}
                        />
                    </Container>
                </BottomDrawer>
            </div>
        </div>
    );
};

export default Payment;

const SelectPayment = ({ onClick, receipts, onMode }) => {
    return (
        <div className=" w-full lg:w-4/5 flex flex-col gap-y-2.4">
            <div className="text-center bg-gray-100 py-1 rounded-sm hidden lg:block">
                <H4 className="sm:text-base 2xl:text-base font-vietnam lg:font-urbanist">
                    Select Payment
                </H4>
            </div>
            <P className="font-vietnam lg:font-urbanist">
                Choose the payment from the list and select the mode of payment
            </P>

            {receipts.length === 0 ? (
                <AlertNew>
                    <P>No receipts available</P>
                </AlertNew>
            ) : (
                receipts.map((item, index) => {
                    let isActive =
                        item.status === "PAID"
                            ? false
                            : receipts[index - 1]
                            ? receipts[index - 1]?.status === "PAID"
                            : true;
                    return (
                        <div key={index}>
                            <PaymentCard
                                heading={item?.name}
                                status={item?.status}
                                statusType={
                                    item?.status === "PAID" ? "success" : "warn"
                                }
                                due={item?.amountDue}
                                paid={item?.amountPaid}
                                isSelected={isActive}
                            />
                            {isActive && (
                                <button
                                    onClick={onMode}
                                    className="text-blue-100 underline  font-vietnam mt-1 text-sm lg:hidden"
                                >
                                    Show Payment mode
                                </button>
                            )}
                        </div>
                    );
                })
            )}

            <Button
                className="w-full font-vietnam lg:font-urbanist"
                onClick={onClick}
            >
                Payment Confirmation
            </Button>
        </div>
    );
};

const PaymentMode = ({
    paymentMode,
    setPaymentMode,
    currentTab,
    setCurrentTab,
    setShowModal,
    virtualAccount,
    type,
}) => {
    return (
        <div className="w-full lg:w-4/5">
            <P className="text-primary font-vietnam lg:font-urbanist text-base xl:text-base 2xl:text-base mb-1.5 xl:mb-0 ">
                Choose Payment Mode
            </P>
            <div className="xl:p-1.5 flex gap-1 items-center w-full">
                <div className="h-3 w-3 rounded-full bg-gray-60 flex items-center justify-center">
                    <RadioInput
                        value={MODE.upi}
                        checked={paymentMode === MODE.upi}
                        onChange={() => setPaymentMode(MODE.upi)}
                        name={type + "mode"}
                        id={MODE.upi}
                        activeColor="bluePrimary"
                    />
                </div>
                <div className="flex-1">
                    <div className="flex items-center justify-between">
                        <P className="xlg:text-sm 2xl:text-sm font-vietnam lg:font-urbanist">
                            UPI, RTGS, IMPS, NEFT
                        </P>
                        <div>
                            <div>
                                <PaymentStatus
                                    status="Fast"
                                    statusType="success"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center justify-between mt-0.8">
                        <P className="!text-xs text-gray-370 font-vietnam lg:font-urbanist">
                            Payment confirmation time
                        </P>
                        <P className=" text-gray-330 text-xs  sm:text-sm md:text-sm xl:text-sm 2xl:text-sm font-vietnam lg:font-urbanist">
                            5 Min
                        </P>
                    </div>
                </div>
            </div>
            <div className="xl:p-1.5 flex gap-1 items-center w-full my-1.5 lg:my-0">
                <div className="h-3 w-3 rounded-full bg-gray-60 flex items-center justify-center">
                    <RadioInput
                        value={MODE.cheque}
                        checked={paymentMode === MODE.cheque}
                        onChange={() => setPaymentMode(MODE.cheque)}
                        name={type + "mode"}
                        id={MODE.cheque}
                        activeColor="bluePrimary"
                    />
                </div>
                <div className="flex-1">
                    <div className="flex items-center justify-between">
                        <P className="lg:text-sm 2xl:text-sm font-vietnam lg:font-urbanist">
                            Cheque
                        </P>
                        <div>
                            <div>
                                <PaymentStatus
                                    status="Slow"
                                    statusType="warn"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex items-center justify-between mt-0.8">
                        <P className="!text-xs text-gray-370 font-vietnam lg:font-urbanist">
                            Payment confirmation time
                        </P>
                        <P className="text-gray-330 text-xs  sm:text-sm md:text-sm xl:text-sm 2xl:text-sm font-vietnam lg:font-urbanist">
                            3-4 Days
                        </P>
                    </div>
                </div>
            </div>

            {paymentMode === MODE.cheque ? (
                <>
                    <P className="text-primary text-base font-vietnam lg:font-urbanist ">
                        Cheque Payment
                    </P>
                    <P className="text-gray-370 !text-xs font-vietnam lg:font-urbanist">
                        Make cheque payment in favor of our company account and
                        upload cheque image in payment confirmation section
                    </P>

                    <div className="text-center bg-gray-100 py-1 rounded-sm my-1.8">
                        <P className="!text-xs  mb-0.5 text-center font-vietnam lg:font-urbanist">
                            Cheque in favor of
                        </P>
                        <H4 className="sm:text-base 2xl:text-base font-vietnam lg:font-urbanist">
                            HYPERSROT TECHNOLOGIES PVT LTD
                        </H4>
                    </div>
                    <P className="text-primary xl:text-base 2xl:text-base mb-0.5 ">
                        Cheque Pickup
                    </P>
                    <P className="text-gray-370 !text-xs font-vietnam lg:font-urbanist">
                        Call Sales Executive for door step cheque pickup
                    </P>

                    <Button
                        onClick={() => setShowModal(true)}
                        className="w-full bg-transparent border border-solid mt-1.8 text-primary border-primary hover:border-blue font-vietnam lg:font-urbanist"
                    >
                        Call Sales Executive
                    </Button>
                </>
            ) : (
                <>
                    <P className="text-primary text-base font-vietnam lg:font-urbanist  ">
                        Make Payment
                    </P>
                    <P className="text-gray-370 !text-xs font-vietnam lg:font-urbanist ">
                        Add bank account, transfer funds or pay by UPI and share
                        payment confirmation receipt
                    </P>
                    <BorderedTab
                        currentTab={currentTab}
                        onTabClick={(tab) => setCurrentTab(tab)}
                        options={["Bank Transfer", "UPI"]}
                        className="bg-transparent gap-0 my-2.4 xl:my-1.5 border rounded-sm font-vietnam lg:font-urbanist"
                        activeClass={`w-1/2 rounded-none bg-gray-100 text-primary rounded-none text-sm ${
                            currentTab === 0
                                ? "rounded-r-none"
                                : "rounded-l-none"
                        } `}
                        inActiveClass="w-1/2 rounded-none bg-transparent text-primary text-sm"
                    />
                    {currentTab === 0 ? (
                        <>
                            {bankData(virtualAccount).map((item, index) => (
                                <div
                                    key={index}
                                    className="grid grid-cols-2 mb-0.8"
                                >
                                    <P className="xl:text-sm 2xl:text-sm font-vietnam lg:font-urbanist font-thin lg:font-normal">
                                        {item.name}
                                    </P>
                                    <P className="xl:text-sm 2xl:text-sm font-vietnam lg:font-urbanist font-thin lg:font-normal">
                                        {item.value}
                                    </P>
                                </div>
                            ))}
                        </>
                    ) : (
                        <>
                            <div className="h-auto my-0 mx-auto max-w-[150px] xl:max-w-[200px] w-full">
                                <QRCode
                                    size={256}
                                    fgColor="#356BDB"
                                    level="L"
                                    style={{
                                        height: "auto",
                                        maxWidth: "100%",
                                        width: "100%",
                                    }}
                                    value={`upi://pay?pa=rpy.${virtualAccount?.upiId}&pn=Hypersrot&tn=Test&cu=INR`}
                                    viewBox={`0 0 256 256`}
                                />
                            </div>
                            <div className="text-center bg-gray-100 py-1 rounded-sm mt-1">
                                <P className="sm:text-base 2xl:text-base font-vietnam lg:font-urbanist font-thin lg:font-normal">
                                    UPI ID: {virtualAccount?.upiId}
                                </P>
                            </div>
                        </>
                    )}
                </>
            )}
        </div>
    );
};
const bankData = (data) => [
    {
        name: "Account Name:",
        value: data?.accountName,
    },
    {
        name: "Bank Name:",
        value: "Axis Bank, Razorpay",
    },
    {
        name: "Bank IFSC:",
        value: data?.ifsc,
    },
    {
        name: "Account Number:",
        value: data?.accountNumber,
    },
    {
        name: "Payment Mode:",
        value: "IMPS, RTGS, NEFT",
    },
];
